import { Link } from 'react-router-dom';
import { Package, Box, ExternalLink } from 'lucide-react';
import type { BundleItem } from '../../types/products';

interface ProductBundleItemsProps {
  items: BundleItem[];
  title?: string;
}

export function ProductBundleItems({ items, title = 'Enthaltene Produkte' }: ProductBundleItemsProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-gray-100 dark:border-slate-700 overflow-hidden">
      <div className="flex items-center gap-3 p-4 border-b border-gray-100 dark:border-slate-700">
        <div className="w-10 h-10 bg-violet-50 dark:bg-violet-900/30 rounded-xl flex items-center justify-center">
          <Box className="w-5 h-5 text-violet-600 dark:text-violet-400" />
        </div>
        <h3 className="font-semibold text-[#1A1A1A] dark:text-white">{title}</h3>
        <span className="ml-auto text-sm text-[#6B6B6B] dark:text-slate-400">{items.length} Produkte</span>
      </div>

      <div className="divide-y divide-gray-100 dark:divide-slate-700">
        {items.map((item) => (
          <div key={item.id} className="flex items-center gap-4 p-4">
            <div className="w-12 h-12 bg-gray-100 dark:bg-slate-700 rounded-xl flex items-center justify-center flex-shrink-0">
              <Package className="w-6 h-6 text-gray-400 dark:text-slate-500" />
            </div>

            <div className="flex-1 min-w-0">
              {item.child_product ? (
                <Link
                  to={`/products/${item.child_product.slug}`}
                  className="font-medium text-[#1A1A1A] dark:text-white hover:text-primary transition-colors flex items-center gap-1"
                >
                  {item.child_product_name}
                  <ExternalLink className="w-3.5 h-3.5" />
                </Link>
              ) : (
                <span className="font-medium text-[#1A1A1A] dark:text-white">{item.child_product_name}</span>
              )}

              {item.quantity_text && (
                <p className="text-sm text-[#6B6B6B] dark:text-slate-400">{item.quantity_text}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
